/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ
     */
    Height?: number | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ {
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ {
    if (json == null) {
        return json;
    }
    return {
        
        'Height': json['Height'] == null ? undefined : json['Height'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Height': value['Height'],
    };
}

